import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { findSparePartsCountByDateType } from '@/service/purchase/spareParts';
export default function useTotalData(params) {
  var totalData = ref({
    totMoney: 0,
    singular: 0
  });
  var getTotalDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return findSparePartsCountByDateType(params.value);
          case 2:
            data = _context.sent;
            totalData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getTotalDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var summaryData = computed(function () {
    var _totalData$value, _totalData$value2;
    var type = '';
    if (params.value.type === 0) {
      type = '本日';
    }
    if (params.value.type === 1) {
      type = '本周';
    }
    if (params.value.type === 2) {
      type = '本月';
    }
    if (params.value.type === 3) {
      type = '本年';
    }
    if (params.value.type === 4) {
      type = '总';
    }
    return [{
      num: (_totalData$value = totalData.value) === null || _totalData$value === void 0 ? void 0 : _totalData$value.singular,
      desc: "".concat(type, "\u5355\u6570/\u5355")
    }, {
      num: (_totalData$value2 = totalData.value) === null || _totalData$value2 === void 0 ? void 0 : _totalData$value2.totMoney,
      desc: "".concat(type, "\u91D1\u989D/\u4E07")
    }];
  });
  return [totalData, summaryData, getTotalDataAsync];
}